import { Grid, Typography } from '@material-ui/core'

import { addCommaToPrice } from '../../helpers/numbers'
import { getTranslate } from '../../localization'
import { Wallet } from '../../types/wallet'
import { Proforma } from '../../types/walletProforma'
import { useStyles } from './styles/PaymentDetails'

// If needed, import a Jalali date formatter
// import { formatToJalali } from '../../utils/dateUtils'

interface PaymentDetailsProps {
  proforma: Proforma
  wallet: Wallet
}

const PaymentDetails: React.FC<PaymentDetailsProps> = ({
  proforma,
  wallet
}) => {
  const classes = useStyles()

  // const confirmationNumber = wallet?.confirmationNumber ?? '—' // fallback if not available

  const invoiceNumber = proforma.proformaNumber

  const totalAmount = proforma.transactions.reduce(
    (sum, tx) => sum + tx.amount + tx.sumOfPenalty - tx.rewardOfEarlyPayment,
    0
  )

  const currency = wallet.currency

  const formattedAmount = addCommaToPrice(totalAmount) + ` ${currency}`

  return (
    <div className={classes.card}>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Typography className={classes.label}>
            {getTranslate('Payment Confirmation Number')}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          {/* TODO: i don't have payment confirmation number */}
          <Typography className={classes.value}>{2937}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography className={classes.label}>
            {getTranslate('Invoice Number')}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography className={classes.value}>{invoiceNumber}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography className={classes.label}>
            {getTranslate('Invoice Date')}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography className={classes.value}>
            {proforma.createdAt}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography className={classes.label}>
            {getTranslate('Total Payment')}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography className={classes.value}>{formattedAmount}</Typography>
        </Grid>
      </Grid>
    </div>
  )
}

export default PaymentDetails
